import currency from "currency.js";

/**
 * Handle currency precision calculations and formatting\
 * _NOTE: input is integer in `öre`, 0.01 SEK_
 * @param {number} value _in `öre`_
 * @returns
 */
const currencySEK = (value: number, symbol = "kr") => {
    const result = currency(value, {
        symbol,
        precision: 2, // value is in öre
        decimal: ",",
        separator: " ",
        fromCents: true,
        pattern: "# !",
        negativePattern: "-# !",
    });

    const formatWithoutSymbol = (options: currency.Options) => {
        return result.format({
            ...options,
            pattern: "#",
            negativePattern: "-#",
        });
    };

    (
        result as typeof result & {
            formatWithoutSymbol: typeof formatWithoutSymbol;
        }
    ).formatWithoutSymbol = formatWithoutSymbol;

    return result;
};

export { currencySEK };
